import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import SaveIcon from '@material-ui/icons/GetApp';
import classNames from 'classnames';
import Loader from '../loader';
import Alert from '../alert';
import ResultTable from '../resultTable';
import {config,settings} from '../../config/config';
import axios from 'axios';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit * 2
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  root: {
    flexGrow: 1
  },
  typography: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px ",
    border: "1px solid #dedede"
  },
  paperDescription: {
    margin: "10px",
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px "
  }
});

class Index extends Component {

  constructor() {
    super();
    this.execDownload = this.execDownload.bind(this);
    this.alertHandleClose = this.alertHandleClose.bind(this);
  }

  state = {
    screenName: "",
    range: "15",
    isDownloading: false,
    isAlertOpen: false,
    alertErrorMessage: "",
    results:{
      data:[]
    }
  };

  async execDownload() {
    if (this.state.isDownloading) {
      return;
    }
    try {
      this.setState({isDownloading: true,isLast: false});
      let parameter = new URLSearchParams();
      parameter.append("type", "inreplyto");
      parameter.append("keyword", this.state.screenName);
      parameter.append("range", this.state.range);
      const response = await axios.post(settings.url + "/get", parameter, config);
      if (response) {
        if(response.data.mes !== "ok"){
          throw response.data.reason;
        }else{
          const isLast = response.data.result.nextCursor === "-1" ? true : false;
          this.setState({isDownloading: false,results:{data:response.data.result.data}, cursor:response.data.result.nextCursor, isLast: isLast});
          this.props.updateApiLimits(response.data.result.apiLimits);
          if(localStorage.getItem("auto") === "true"){
            for (let i = 0; i < response.data.result.data.length; i++){
              const data = response.data.result.data;
              let link = document.createElement('a');
              link.download = settings.download + data[i]["fileName"];
              link.href = settings.download + data[i]["fileName"];
              link.click();
            }
          }
        }
      }
    } catch(e) {
      this.setState({isDownloading: false,isAlertOpen: true,alertErrorMessage: e});
    }
  }

  handleChangeText = name => event => {
    this.setState({[name]: event.target.value});
  };

  handleChangeChkbox = name => event => {
    this.setState({[name]: event.target.checked});
  };

  alertHandleClose(){
    this.setState({isAlertOpen:false});
  }

  render() {
    const {classes} = this.props;
    return (<div>
      <Grid container={true}>
        <Grid item={true} xs={12}>
          <Paper className={classes.paper}>
            <Typography component="h5" variant="h5" className={classes.typography}>
              In-reply-toから
            </Typography>
            <form className={classes.container} noValidate="noValidate" autoComplete="off">
              <TextField id="outlined-name" label="検索対象ツイートid" className={classes.textField} value={this.state.screenName} fullWidth={true} onChange={this.handleChangeText('screenName')} margin="normal" variant="outlined"/>
              <TextField id="outlined-name" label="検索範囲" className={classes.textField} value={this.state.range} fullWidth={true} onChange={this.handleChangeText('range')} margin="normal" variant="outlined"/>
            </form>
            <Grid container={true} style={{
                alignItems: "center"
              }}>
              <Grid item={true} style={{
                  height: "60px",
                  display: "flex",
                  alignItems: "center"
                }}>
                <Button variant="contained" size="large" color="primary" className={classes.button} onClick={this.execDownload} disabled={this.state.isDownloading}>
                  <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{
                      marginRight: "5px"
                    }}/>
                  ダウンロード
                </Button>
              </Grid>
              <Grid item={true}>
                <Loader isVisible={this.state.isDownloading}/>
              </Grid>
            </Grid>
            <Paper>
              <ResultTable results={this.state.results}/>
            </Paper>
            <Paper className={classes.paperDescription}>
              特定ツイートに対し@リプライを飛ばしている人のリストを取得します。<br/>
            走査方法がゴリ押しで、「特定の人に@リプライを飛ばしている」ツイートを探し出した上でそれぞれのin-reply-to欄をチェックする形になっているので取得漏れが激しいです。<br/>
            検索範囲を大きめにするとちゃんと動くかもしれません。走査範囲は1週間以内のツイートです。<br/>
            検索対象ツイートidとは、当該ツイートのURLの末尾の数字部分です。(<a href="https://twitter.com/AbeShinzo/status/1091876346605649920">このツイート</a>であれば1091876346605649920)<br/>
            スマホからだと末尾にURLパラメータ(例:?s=21)が付くことがありますが、これは除去してください。
            </Paper>
          </Paper>
        </Grid>
      </Grid>
      <Alert open={this.state.isAlertOpen} handleClose={this.alertHandleClose} errorMessage={this.state.alertErrorMessage}/>
    </div>)
  }
}

Index.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Index);
